module.exports = __webpack_public_path__ + "static/media/normal.12f81c91.jpg";